<template>
  <router-link class="news-item" :to="{ name: 'NewsDetail', params:{ id: dataSource.id } }">
    <ImageContainer :image-src="imageUrl" />
    <MarkComponent style="margin-top: 20px;">
      <template>
        <div class="title-group">
          <p class="title"> {{ dataSource.title }}</p>
          <p class="sub-title">{{ dataSource.subTitle }}</p>
        </div>
        <div class="content" v-html="dataSource.content" />
      </template>
    </MarkComponent>
  </router-link>
</template>
<script>
import MarkComponent from '@/components/MarkComponent.vue'
import ImageContainer from '@/components/ImageContainer.vue'

export default {
  components: {
    ImageContainer,
    MarkComponent
  },
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageUrl() {
      return `${process.env.VUE_APP_API_PATH}/file/getImgStream?idFile=${this.dataSource.img}`
    }
  }
}
</script>

<style scoped lang="scss">
.news-item {
  width: 100%;
  text-align: center;
  display: inline-block;
}
.title-group {
  display: flex;
  align-items: center;
  gap: 10px;
  .title {
    color: $mainPurple;
    font-size: 20px;
  }
  .sub-title {
    color: $mainGrey;
    font-size: 16px;
  }
}
.content {
  color: $black;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-align: left;
}
.mark-component {
  margin-bottom: 20px;
}
</style>

